// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IGetVillageSuggestsRequest,
  TGetVillageSuggestsModel,
  IMappers,
  TGetVillageSuggestsResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetVillageSuggestsResponseSchema } from '../../entities/schemas/GetVillageSuggestsResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetVillageSuggestsModel(parameters: IGetVillageSuggestsRequest): TGetVillageSuggestsModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'countryside-search',
    pathApi: '/v1/get-village-suggests/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IGetVillageSuggestsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetVillageSuggestsRequest;
}

export async function fetchGetVillageSuggests<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetVillageSuggestsOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetVillageSuggestsResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetVillageSuggestsModel(parameters),
    config,
  )) as FetchResponse<TGetVillageSuggestsResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetVillageSuggestsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetVillageSuggestsResponse>;
}
